export const enum TaskMonthRecurrency {
    Weekday = "weekday",
    DayOfMonth = "day_of_month"
}


// WEBPACK FOOTER //
// ./src/Models/Tasks/TaskRecurrencies/TaskMonthRecurrency.ts